module.exports = __webpack_public_path__ + "img/service06.2143aaff.png";